





























import { Component, Watch } from 'vue-property-decorator'
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import RateSource from '@/models/Products/RateSources/RateSource';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import RateSourceCreate from '@/components/Products/RateSources/RateSourceCreate.vue';

@Component({ name: 'RateSourcesList', components: { Alert, RateSourceCreate }, metaInfo: { title: 'Rate Sources' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.rateSources.fields.name'), sortable: false, width: '30%' },
        { text: this.$t('pageText.rateSources.fields.baseRate'), sortable: false, width: '15%' },
        { text: this.$t('pageText.rateSources.fields.baseRateSource'), sortable: false, width: '20%' },
        { text: this.$t('pageText.rateSources.fields.updatedBy'), sortable: false, width: '20%' },
        { text: this.$t('pageText.rateSources.fields.updatedAt'), sortable: false, width: '15%' },
    ];
    rateSourcesPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.rateSourcesPage = +page;
        }
    }

    async beforeMount() {
        await RateSourceModule.getRateSources(this.rateSourcesPage);
    }

    get rateSources() {
        return RateSourceModule.rateSources;
    }

    get totalRateSourcesPages() {
        return RateSourceModule.totalRateSourcesPages;
    }

    get loading() {
        return RateSourceModule.loading;
    }

    get pageSize() {
        return RateSourceModule.pageSize;
    }

    baseRateSourceValue(rateSource: RateSource) {
        if (rateSource.baseRate) {
            return this.$t('commonLabels.notSet');
        }
        if (rateSource.baseRateSourceIdentifier) {
            return rateSource.baseRateSourceIdentifier.entityName;
        }
        return this.$t('commonLabels.notSet');
    }

    @Watch('rateSourcesPage')
    async onRateSourcesPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.rateSourcesPage}` } });
        // Get new rate sources
        await RateSourceModule.getRateSources(this.rateSourcesPage);
    }

    async navigateToRateSource(rateSource: RateSource) {
        this.$router.push({ name: PageNames.RateSource, params: { id: rateSource.id }, query: { tab: "0" } });
    }

}
